import React from 'react';
import TaskColumn from './TaskColumn';
import { getTaskWithInitiatives } from './utils';

const InitiativesColumn = ({
  goals,
  selectedGoal,
  selectedStep,
  selectedTask,
  newInitiativeText,
  setNewInitiativeText,
  addInitiative,
  setGoals,
  columnHeaders,
  setColumnHeaders,
  openMenuId,
  setOpenMenuId,
  openSubmenuId,
  setOpenSubmenuId,
  filterState,
  editingItemId,
  setEditingItemId,
  editingText,
  setEditingText,
  draggedItem,
  handleDragStart,
  handleDragOver,
  handleDrop
}) => {
  const initiatives = selectedGoal && selectedStep && selectedTask
    ? (getTaskWithInitiatives(goals, selectedGoal, selectedStep, selectedTask)?.initiatives || [])
    : [];

  const toggleInitiativeCompletion = (initiativeId) => {
    const updatedGoals = goals.map((goal) => {
      if (goal.id === selectedGoal) {
        return {
          ...goal,
          steps: goal.steps.map((step) => {
            if (step.id === selectedStep) {
              return {
                ...step,
                tasks: step.tasks.map((task) => {
                  if (task.id === selectedTask) {
                    return {
                      ...task,
                      initiatives: (task.initiatives || []).map((initiative) =>
                        initiative.id === initiativeId
                          ? { ...initiative, completed: !initiative.completed }
                          : initiative
                      ),
                    };
                  }
                  return task;
                }),
              };
            }
            return step;
          }),
        };
      }
      return goal;
    });
    setGoals(updatedGoals);
  };

  const deleteInitiative = (initiativeId) => {
    const updatedGoals = goals.map((goal) => {
      if (goal.id === selectedGoal) {
        return {
          ...goal,
          steps: goal.steps.map((step) => {
            if (step.id === selectedStep) {
              return {
                ...step,
                tasks: step.tasks.map((task) => {
                  if (task.id === selectedTask) {
                    return {
                      ...task,
                      initiatives: (task.initiatives || []).filter(
                        (initiative) => initiative.id !== initiativeId
                      ),
                    };
                  }
                  return task;
                }),
              };
            }
            return step;
          }),
        };
      }
      return goal;
    });
    setGoals(updatedGoals);
    setOpenMenuId(null);
    setOpenSubmenuId(null);
  };

  const setInitiativePriority = (initiativeId, priority) => {
    const updatedGoals = goals.map((goal) => {
      if (goal.id === selectedGoal) {
        return {
          ...goal,
          steps: goal.steps.map((step) => {
            if (step.id === selectedStep) {
              return {
                ...step,
                tasks: step.tasks.map((task) => {
                  if (task.id === selectedTask) {
                    return {
                      ...task,
                      initiatives: (task.initiatives || []).map((initiative) =>
                        initiative.id === initiativeId
                          ? { ...initiative, priority: priority }
                          : initiative
                      ),
                    };
                  }
                  return task;
                }),
              };
            }
            return step;
          }),
        };
      }
      return goal;
    });
    setGoals(updatedGoals);
    setOpenMenuId(null);
    setOpenSubmenuId(null);
  };

  const updateInitiativeTitle = (initiativeId, newTitle) => {
    const updatedGoals = goals.map(g => 
      g.id === selectedGoal ? {
        ...g, 
        steps: g.steps.map(s => 
          s.id === selectedStep ? {
            ...s,
            tasks: s.tasks.map(t =>
              t.id === selectedTask ? {
                ...t,
                initiatives: (t.initiatives || []).map(i =>
                  i.id === initiativeId ? {...i, title: newTitle} : i
                )
              } : t
            )
          } : s
        )
      } : g
    );
    setGoals(updatedGoals);
    setEditingItemId(null);
  };

  return (
    <TaskColumn
      type="initiative"
      items={initiatives}
      selectedId={null}
      setSelectedId={() => {}}
      newItemText={newInitiativeText}
      setNewItemText={setNewInitiativeText}
      addItem={addInitiative}
      toggleCompletion={toggleInitiativeCompletion}
      columnHeaders={columnHeaders}
      setColumnHeaders={setColumnHeaders}
      headerKey="initiatives"
      openMenuId={openMenuId}
      setOpenMenuId={setOpenMenuId}
      openSubmenuId={openSubmenuId}
      setOpenSubmenuId={setOpenSubmenuId}
      deleteItem={deleteInitiative}
      setPriority={setInitiativePriority}
      goalId={selectedGoal}
      stepId={selectedStep}
      taskId={selectedTask}
      filterState={filterState}
      editingItemId={editingItemId}
      setEditingItemId={setEditingItemId}
      editingText={editingText}
      setEditingText={setEditingText}
      updateItemTitle={updateInitiativeTitle}
      draggedItem={draggedItem}
      handleDragStart={handleDragStart}
      handleDragOver={handleDragOver}
      handleDrop={handleDrop}
      isDisabled={!selectedGoal || !selectedStep || !selectedTask}
    />
  );
};

export default InitiativesColumn; 